import { useEffect } from "react";
import { useNavigate } from "react-router";

export const useInitialRedirect = ({
  redirectTo,
  storageKey = "has_visited_root",
}: {
  redirectTo: string;
  storageKey?: string;
}) => {
  const navigate = useNavigate();

  useEffect(() => {
    const alreadyRedirected = sessionStorage.getItem(storageKey);

    if (!alreadyRedirected) {
      sessionStorage.setItem(storageKey, "true");
      navigate(redirectTo, { replace: true });
    }
  }, [navigate, redirectTo, storageKey]);
};
